import type { EventFeedbackPayload } from '@/features/publicsite/types/events/EventFeedbackPayload';
import type { EventFeedbackValues } from '@/features/publicsite/types/events/EventFeedbackValues';
import type { EventParticipation } from '@/features/publicsite/types/events/EventParticipation';

/** The evaluation form → POST /feedback's body. A blank free-text answer is sent as null. */
export function feedbackPayload(v: EventFeedbackValues): EventFeedbackPayload {
  return {
    rating: v.rating,
    comments: v.comments || null,
    presentationRating: v.presentationRating,
    futureNeeds: v.futureNeeds || null,
  };
}

/** What the participant's own relationship to the event reads once their evaluation is accepted. */
export function participationAfterFeedback(v: EventFeedbackValues): EventParticipation {
  return {
    registered: true,
    // Only a participant marked present can have had an evaluation accepted, and after the event
    // there is no registration left to withdraw.
    attended: true,
    mayCancel: false,
    // The server would refuse a second one, so the local copy has to say so too — otherwise
    // the form stays on screen until the next load and the next press returns a 409.
    mayLeaveFeedback: false,
    feedbackSubmitted: true,
    myRating: v.rating,
    myComments: v.comments || null,
    myPresentationRating: v.presentationRating,
    myFutureNeeds: v.futureNeeds || null,
  };
}
